export const PROJECTS_QUERY_KEY = ["opportunities"];
